<template>
    <div>
        <UiCardListHeader
            :action-href="report.url || ''"
            :action-label="lang('reports::reports.actions.show')"
        >
            <template #title>
                <span v-if="report.label">{{ report.label }}</span>
            </template>
        </UiCardListHeader>

        <div v-if="report && report.id" class="min-h-[50vh]">
            <Chart :report="report" chart-class="min-h-[50vh]"></Chart>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import Chart from '@src/Reports/Pages/Partials/Chart.vue';

const props = defineProps({
    settings: {
        type: Object,
        required: true,
    },
});

const report = ref({});

const load = () => {
    axios
        .get(route('reports.admin.api.preview'), {
            params: {
                settings: props.settings,
            },
        })
        .then(({ data }) => {
            report.value = data.report;
        });
};

load();
</script>
